import { API, API_POST } from "../../../Config";

export const handleAddDiet = (payload) => {
  const f = new FormData();
  console.log(payload);
  f.append("title", payload.title);
  f.append("photo", payload.image);
  f.append("recipe_id", payload.recipe_id);
  f.append("cat_id", payload.diet_category);
  return API_POST(API.AddDiet, f);
};
